<template>
  <div class="text-xl font-semibold">
    <slot></slot>
  </div>
</template>
